import script from "./OrderTotal.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderTotal.vue?vue&type=script&setup=true&lang=ts"

import "./OrderTotal.vue?vue&type=style&index=0&id=1664b3fc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1664b3fc"]])

export default __exports__